/* =========================================================
   GIFTBOX — The Bridge
   Una sola confezione, nessun match dimensionale.
   Collegamento al prodotto in properties._linked_item.

   Due contesti, handler condivisi:
   - pagina carrello  (#cart-form, render Liquid)
   - drawer minicart  (#CartContainer, render Handlebars)

   Non modifica nessun file del tema: il drawer viene arricchito
   dall'esterno via MutationObserver, cosi sopravvive a una
   rigenerazione dei bundle.
   ========================================================= */
(function () {
  'use strict';

  /* ══════════ CONFIG ══════════ */

  var cfgEl = document.getElementById('giftbox-tb-data');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (err) {
    console.error('[GIFTBOX] config non valida', err);
    return;
  }
  if (!CFG || !CFG.variantId) return;

  var DRAWER = '#CartContainer';

  var STR = {
    add: (CFG.strings && CFG.strings.add) || 'Aggiungi confezione regalo',
    added: (CFG.strings && CFG.strings.added) || 'Confezione regalo',
    remove: (CFG.strings && CFG.strings.remove) || 'Rimuovi',
    less: (CFG.strings && CFG.strings.less) || 'Riduci di uno',
    more: (CFG.strings && CFG.strings.more) || 'Aumenta di uno',
    qty: (CFG.strings && CFG.strings.qty) || 'Quantita'
  };

  /* ══════════ HELPER ══════════ */

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function isGiftbox(item) {
    return String(item.variant_id) === String(CFG.variantId);
  }

  function parentKeyOf(item) {
    return (item.properties && item.properties._linked_item) || null;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.strings && theme.strings.moneyFormat);
    }
    return CFG.priceFormatted || '';
  }

  function inDrawer(el) {
    return !!(el && el.closest && el.closest(DRAWER));
  }

  // aggiorna il badge in testata senza aspettare il tema
  function touchCounter() {
    if (!window.ShopifyAPI || typeof ShopifyAPI.updateCartItemsCount !== 'function') return;
    getCart().then(function (cart) {
      try { ShopifyAPI.updateCartItemsCount(cart); } catch (e) { /* noop */ }
    });
  }

  /* Dopo una mutazione: nel drawer emettiamo shopify:cart_add, che
     theme.liquid gia intercetta con ajaxCart.load(). Sulla pagina
     carrello ricarichiamo, perche il JS del tema non sa ridisegnare
     prezzo di riga e subtotale di una riga che non conosce. */
  function refreshAfter(originEl) {
    if (inDrawer(originEl)) {
      document.dispatchEvent(new CustomEvent('shopify:cart_add'));
      touchCounter();
      return;
    }
    window.location.reload();
  }

  function setBusy(originEl, on) {
    if (inDrawer(originEl)) {
      document.body.classList[on ? 'add' : 'remove']('drawer--is-loading');
      return;
    }
    var section = document.querySelector('.cart-section');
    if (section) section.classList[on ? 'add' : 'remove']('is-loading');
  }

  /* ══════════ MARKUP CONDIVISO ══════════ */

  function addHtml(parentKey) {
    return '' +
      '<div class="gb-add" data-giftbox-injected>' +
        '<label class="gb-add__label">' +
          '<input type="checkbox" class="gb-add__checkbox" data-giftbox-add="' + esc(parentKey) + '">' +
          '<span class="gb-add__icon" aria-hidden="true">\uD83C\uDF81</span>' +
          '<span class="gb-add__text">' + esc(STR.add) + '</span>' +
        '</label>' +
        '<span class="gb-add__price">' + esc(CFG.priceFormatted || '') + '</span>' +
      '</div>';
  }

  function panelHtml(gift, parent) {
    var atMin = gift.quantity <= 1;
    var atMax = gift.quantity >= parent.quantity;
    return '' +
      '<div class="gb-panel" data-giftbox-injected>' +
        '<div class="gb-panel__head">' +
          '<span class="gb-panel__label">' + esc(STR.added) + '</span>' +
          '<span class="gb-panel__price">' + esc(money(gift.final_line_price)) + '</span>' +
        '</div>' +
        '<div class="gb-panel__actions">' +
          '<div class="gb-qty">' +
            '<button type="button" class="gb-qty__btn" data-giftbox-minus="' + esc(gift.key) + '"' +
              ' aria-label="' + esc(STR.less) + '"' + (atMin ? ' disabled' : '') + '>&minus;</button>' +
            '<input type="text" inputmode="numeric" pattern="[0-9]*" class="gb-qty__num"' +
              ' value="' + gift.quantity + '" data-giftbox-qty="' + esc(gift.key) + '"' +
              ' data-giftbox-max="' + parent.quantity + '" aria-label="' + esc(STR.qty) + '"' +
              ' readonly tabindex="-1">' +
            '<button type="button" class="gb-qty__btn" data-giftbox-plus="' + esc(gift.key) + '"' +
              ' aria-label="' + esc(STR.more) + '"' + (atMax ? ' disabled' : '') + '>+</button>' +
          '</div>' +
          '<button type="button" class="gb-panel__remove underline-hover" data-giftbox-remove="' +
            esc(gift.key) + '">' + esc(STR.remove) + '</button>' +
        '</div>' +
      '</div>';
  }

  /* ══════════ HANDLER CONDIVISI ══════════ */

  /* --- aggiunta --- */
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.hasAttribute || !cb.hasAttribute('data-giftbox-add')) return;
    if (!cb.checked) return;

    var parentKey = cb.getAttribute('data-giftbox-add');
    cb.disabled = true;
    setBusy(cb, true);

    getCart().then(function (cart) {
      var parent = cart.items.filter(function (i) {
        return String(i.key) === String(parentKey);
      })[0];

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: CFG.variantId,
            quantity: parent ? parent.quantity : 1,
            properties: { _linked_item: parentKey }
          }]
        })
      });
    }).then(function () {
      refreshAfter(cb);
    }).catch(function (err) {
      console.error('[GIFTBOX] add error', err);
      cb.disabled = false;
      cb.checked = false;
      setBusy(cb, false);
    });
  });

  /* --- rimozione della sola giftbox --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-giftbox-remove]') : null;
    if (!btn) return;

    e.preventDefault();
    btn.disabled = true;
    setBusy(btn, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-giftbox-remove'), quantity: 0 })
    }).then(function () {
      refreshAfter(btn);
    }).catch(function (err) {
      console.error('[GIFTBOX] remove error', err);
      btn.disabled = false;
      setBusy(btn, false);
    });
  });

  /* --- selettore quantita ---
     Il massimo si legge dal carrello reale, non da un data-max nel
     markup: un data-max stantio era la causa delle quantita che
     sfuggivano al vincolo su Piquadro. */
  function applyGiftboxQty(key, compute, originEl) {
    setBusy(originEl, true);

    getCart().then(function (cart) {
      var item = cart.items.filter(function (i) {
        return String(i.key) === String(key);
      })[0];
      if (!item) throw new Error('giftbox non trovata: ' + key);

      var pk = parentKeyOf(item);
      var parent = cart.items.filter(function (i) {
        return String(i.key) === String(pk);
      })[0];

      // padre assente: non tocchiamo la quantita, ci pensa reconcile
      if (!parent) {
        setBusy(originEl, false);
        return null;
      }

      var max = parent.quantity;
      var qty = compute(item.quantity, max);
      if (qty < 1) qty = 1;
      if (qty > max) qty = max;

      if (qty === item.quantity) {
        setBusy(originEl, false);
        return null;
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        refreshAfter(originEl);
      });
    }).catch(function (err) {
      console.error('[GIFTBOX] qty error', err);
      setBusy(originEl, false);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var minus = e.target.closest('[data-giftbox-minus]');
    if (minus) {
      applyGiftboxQty(minus.getAttribute('data-giftbox-minus'), function (q) { return q - 1; }, minus);
      return;
    }

    var plus = e.target.closest('[data-giftbox-plus]');
    if (plus) {
      applyGiftboxQty(plus.getAttribute('data-giftbox-plus'), function (q) { return q + 1; }, plus);
    }
  });

  function commitTypedQty(input) {
    var typed = parseInt(String(input.value).replace(/\D/g, ''), 10);
    applyGiftboxQty(input.getAttribute('data-giftbox-qty'), function () {
      return isNaN(typed) ? 1 : typed;
    }, input);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.hasAttribute || !e.target.hasAttribute('data-giftbox-qty')) return;
    commitTypedQty(e.target);
  });

  // input type=text: l'Enter non fa submit implicito, lo gestiamo noi
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.hasAttribute || !e.target.hasAttribute('data-giftbox-qty')) return;
    e.preventDefault();
    commitTypedQty(e.target);
  });

  /* ══════════ PULIZIA WIDGET DEL TEMA ══════════
     qtySelectors in layout.theme.js fa $('input[type="number"]') su
     tutta la pagina e sostituisce ogni match col widget #JsQty, che
     non parla con le API. Il nostro input e type="text" quindi non
     viene preso, ma se un widget finisce comunque dentro il pannello
     lo togliamo: duplicherebbe i bottoni senza aggiornare niente. */

  function stripThemeQtyWidgets() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.gb-panel .js-qty, .gb-panel .js-qty__adjust, .gb-panel .js-qty__num'),
      function (el) { el.remove(); }
    );
  }

  stripThemeQtyWidgets();
  if (window.jQuery) {
    window.jQuery(document).on('InitializedNumberInputs', stripThemeQtyWidgets);
  }
  setTimeout(stripThemeQtyWidgets, 500);

  /* ══════════ CLAMP CONDIVISO ══════════
     Le giftbox non possono superare la quantita del padre. Vale in
     entrambi i contesti: nel drawer il tema ridisegna a ogni cambio
     quantita e il controllo passa da enhanceDrawer, sulla pagina
     carrello da scheduleReconcile. */

  var clamping = false;

  function computeClamp(cart) {
    var updates = {};

    cart.items.forEach(function (item) {
      if (!isGiftbox(item)) return;

      var pk = parentKeyOf(item);
      if (!pk) return;

      var parent = cart.items.filter(function (i) {
        return String(i.key) === String(pk);
      })[0];

      if (!parent) {
        // padre rimosso: la giftbox e orfana. Sicuro perche
        // l'identificazione e per variant id da config e
        // consideriamo solo righe che hanno _linked_item.
        updates[item.key] = 0;
        return;
      }

      if (item.quantity > parent.quantity) {
        updates[item.key] = parent.quantity;
      }
    });

    return updates;
  }

  function pushClamp(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  /* ══════════════════════════════════════════════════════
     MODULO PAGINA CARRELLO
     ══════════════════════════════════════════════════════ */

  var form = document.getElementById('cart-form');

  if (form) {

    function giftboxInputFor(parentKey) {
      var all = form.querySelectorAll('[data-giftbox-input]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('data-giftbox-parent') === parentKey) return all[i];
      }
      return null;
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-giftbox-price]'),
      function (el) { el.textContent = CFG.priceFormatted || ''; }
    );

    /* --- remove a cascata ---
       L'handler del tema mette a 0 il .js-qty__num della riga e poi
       serializza tutto il form. In capture phase azzeriamo anche
       l'hidden della giftbox: una sola update.js con due zeri.
       Deterministico perche il tema non calcola nulla prima di
       serializzare. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.cart__form__meta__remove a') : null;
      if (!link) return;
      var row = link.closest('.cart__form__row--product');
      if (!row) return;
      var input = giftboxInputFor(row.dataset.lineKey);
      if (input) input.value = 0;
    }, true);

    /* --- clamp dopo l'update del tema ---
       Non anticipiamo il tema in capture phase: l'incremento del
       selettore e la serializzazione stanno in handler distinti e
       l'ordine non e garantito. Agiamo dopo, su dati certi. */
    function reconcile() {
      if (clamping) return;
      clamping = true;

      getCart().then(function (cart) {
        var updates = computeClamp(cart);

        if (!Object.keys(updates).length) {
          clamping = false;
          return null;
        }

        return pushClamp(updates).then(function () {
          window.location.reload();
        });
      }).catch(function (err) {
        console.error('[GIFTBOX] clamp error', err);
        clamping = false;
      });
    }

    // il tema non emette eventi: aspettiamo che sparisca is-loading
    function scheduleReconcile() {
      var section = document.querySelector('.cart-section');
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        var busy = section && section.classList.contains('is-loading');
        if (!busy || tries > 30) {
          clearInterval(iv);
          reconcile();
        }
      }, 200);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (inDrawer(e.target)) return;
      if (!e.target.closest('.js-qty button, .js-qty__adjust')) return;
      scheduleReconcile();
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      if (inDrawer(e.target)) return;
      if (!e.target.matches('.js-qty__num, input[name="updates[]"]')) return;
      if (e.target.hasAttribute('data-giftbox-input')) return;
      scheduleReconcile();
    });
  }

  /* ══════════════════════════════════════════════════════
     MODULO DRAWER
     Il tema cancella le properties con underscore prima di
     passare i dati a Handlebars, quindi il template non puo
     vedere _linked_item. Ma ogni riga porta data-id con la
     line key, e da quella risaliamo al carrello reale.
     ══════════════════════════════════════════════════════ */

  var drawer = document.querySelector(DRAWER);

  if (drawer) {

    function rowKey(row) {
      var el = row.querySelector('[data-id]');
      return el ? el.getAttribute('data-id') : null;
    }

    function enhanceDrawer() {
      var rows = drawer.querySelectorAll('.ajaxcart__product');
      if (!rows.length) return;

      // niente da fare: evitiamo un fetch inutile a ogni mutazione
      var pending = false;
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].hasAttribute('data-giftbox-done')) { pending = true; break; }
      }
      if (!pending) return;

      getCart().then(function (cart) {

        /* CLAMP — qui il tema ha gia ridisegnato dopo un cambio
           quantita, quindi e il punto giusto per riallineare le
           giftbox in eccesso. Riusiamo il carrello appena scaricato
           invece di fare un secondo fetch. */
        if (!clamping) {
          var updates = computeClamp(cart);
          if (Object.keys(updates).length) {
            clamping = true;
            return pushClamp(updates).then(function () {
              clamping = false;
              // il tema ridisegna, l'observer ci richiama e al secondo
              // giro non c'e piu nulla da allineare
              document.dispatchEvent(new CustomEvent('shopify:cart_add'));
              touchCounter();
            }).catch(function (err) {
              console.error('[GIFTBOX] clamp drawer error', err);
              clamping = false;
            });
          }
        }

        var byKey = {};
        var giftByParent = {};

        cart.items.forEach(function (item) {
          byKey[item.key] = item;
          if (!isGiftbox(item)) return;
          var pk = parentKeyOf(item);
          if (pk) giftByParent[pk] = item;
        });

        Array.prototype.forEach.call(rows, function (row) {
          if (row.hasAttribute('data-giftbox-done')) return;

          var key = rowKey(row);
          if (!key) return;

          var item = byKey[key];
          if (!item) return;

          row.setAttribute('data-giftbox-done', '1');

          // la riga giftbox non si mostra: compare dentro il padre
          if (isGiftbox(item)) {
            row.style.display = 'none';
            return;
          }

          // a fondo riga, sotto il blocco prodotto, a tutta larghezza:
          // nel drawer lo spazio orizzontale e stretto
          var gift = giftByParent[key];
          row.insertAdjacentHTML('beforeend', gift ? panelHtml(gift, item) : addHtml(key));
        });

        stripThemeQtyWidgets();
      }).catch(function (err) {
        console.error('[GIFTBOX] drawer error', err);
      });
    }

    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(enhanceDrawer, 80);
    }).observe(drawer, { childList: true, subtree: true });

    enhanceDrawer();
  }

  /* ══════════ debug ══════════ */
  window.GiftboxTB = { CFG: CFG, getCart: getCart, isGiftbox: isGiftbox };

})();
